module.exports = __webpack_public_path__ + "static/media/Harlan Brumm.7551d36f.png";